export { default as GenericCarousel } from '../GenericCarousel/GenericCarousel';
